import { gql } from '@apollo/client'

export const GuildFragment = gql`
  fragment Guild on GuildBasicInfo {
    iconURL
    id
    name
    tag
  }
`

export const GuildPvERecordFragment = gql`
  fragment PvEGuildRecord on PVEGuildLeaderboardRecord {
    guild {
      ...Guild
    }
    best3 {
      bestTime
      maxRooms
    }
    guildTotal {
      bestTime
      maxRooms
    }
    rank
  }
  ${GuildFragment}
`

export const GuildPvPRecordFragment = gql`
  fragment PvPGuildRecord on PVPGuildLeaderboardRecord {
    guild {
      ...Guild
    }
    best3 {
      stars
      mmr
    }
    guildTotal {
      stars
      mmr
    }
    rank
  }
  ${GuildFragment}
`
